import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Define initial state type
type InitStateType = {
    startDate: string;
    endDate: string;
};

// Initial state
const INIT_STATE: InitStateType = { startDate: "", endDate: "" };

const advancedDateSlice = createSlice({
    name: "advancedDate",
    initialState: INIT_STATE,
    reducers: {
        getAdvancedPeriodDate(
            state,
            action: PayloadAction<{ startDate: string; endDate: string }>
        ) {
            state.startDate = action.payload.startDate;
            state.endDate = action.payload.endDate;
        },
    },
});

// Export the action
export const { getAdvancedPeriodDate } = advancedDateSlice.actions;

// Export the reducer
export default advancedDateSlice.reducer;
